export default {
  "content": "<path d=\"M3 8.001a2 2 0 100-4 2 2 0 000 4zM10 8a4 4 0 100-8 4 4 0 000 8zm3 2H7a3 3 0 00-3 3v2.775a.225.225 0 00.225.225h11.55a.225.225 0 00.225-.225V13a3 3 0 00-3-3z\" fill=\"#fff\"/><path d=\"M5.535 9.287A1.2 1.2 0 004.775 9h-3.55A1.224 1.224 0 000 10.225v3.591A.184.184 0 00.184 14H3v-1a4 4 0 012.535-3.713z\" fill=\"#fff\"/>",
  "attrs": {
    "width": "32",
    "height": "32",
    "viewBox": "0 -6.5 16 32",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};